import { render } from "./WorkSessionModal.vue?vue&type=template&id=1f7873c9"
import script from "./WorkSessionModal.vue?vue&type=script&lang=js"
export * from "./WorkSessionModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__